import { Link, useNavigate, useParams } from "react-router-dom";
import { capitalize } from "../utils/functions";
import { useEffect } from "react";
import { ArrowRight, CheckCircle2 } from "lucide-react";
import { useGetStoreDetailsForOnlineOrder } from "../api/api.get";

export default function StoreStatusPage() {
  const { id } = useParams();
  const { data: onlineStoreDetailsData, error } =
    useGetStoreDetailsForOnlineOrder(id);
  const navigate = useNavigate();

  useEffect(() => {
    if (error) {
      if ((error as any).status === 404) {
        navigate("/not-found");
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [error]);

  return (
    <div className="min-h-screen pb-32 mx-auto max-w-2xl px-6 sm:px-10 bg-gray-50">
      <div className="py-4 flex items-center justify-center my-6 flex-col gap-2">
        <img
          src="/assets/logo.png"
          alt="expensehut-logo"
          width={50}
          className="rounded-xl"
        />
        <strong className="text-xs">Every Sale Matters </strong>
      </div>

      {/* Success banner */}
      <div className="flex items-start gap-3 rounded-xl border border-green-200 bg-green-50 p-4 mb-6 shadow-sm">
        <CheckCircle2 className="text-green-600 flex-shrink-0" size={22} />
        <div>
          <p className="text-sm font-semibold text-green-800">
            You're all set!
          </p>
          <p className="text-xs text-green-700 mt-0.5">
            If you are seeing this page, it means you have configured your
            settings correctly.
          </p>
        </div>
      </div>

      {onlineStoreDetailsData && (
        <div
          className="flex flex-col items-center text-center gap-4 rounded-xl p-8 sm:p-10 shadow-sm"
          style={{
            background: onlineStoreDetailsData?.bodyBackgroundColor,
            color: onlineStoreDetailsData?.bodyFontColor ?? "black",
          }}
        >
          <div className="flex-shrink-0">
            <img
              src={
                onlineStoreDetailsData?.logo ??
                "/assets/images/generic-logo.svg"
              }
              alt={"logo"}
              className="w-20 h-20 object-cover rounded-lg shadow-sm border border-gray-200"
            />
          </div>

          {/* Merchant Info */}
          <div className="flex-1">
            {/* Restaurant Name */}
            <h1 className="text-lg font-bold mb-0.5">
              {capitalize(onlineStoreDetailsData?.name)}
            </h1>

            {/* Address - Compact */}
            <div className="text-xs space-y-0.5">
              <p>{onlineStoreDetailsData?.street1}</p>
              {onlineStoreDetailsData?.street2 && (
                <p>{onlineStoreDetailsData.street2}</p>
              )}
              <p>
                {onlineStoreDetailsData?.city}, {onlineStoreDetailsData?.state}{" "}
                {onlineStoreDetailsData?.zipCode}
              </p>
            </div>
          </div>

          <div className="flex items-center justify-center gap-2 my-4">
            <span className="border border-green-500 rounded-full px-3 py-1 text-white bg-green-600 text-sm font-bold flex items-center gap-1">
              <img
                src="/assets/icons/ready.png"
                alt="ready"
                width={20}
                height={20}
              />
              ACTIVE
            </span>
          </div>

          <hr className="border-gray-500 w-full" />

          <div className="py-2 gap-4 flex flex-col items-center w-full">
            <strong>Links</strong>

            <Link
              to={`/stores/${onlineStoreDetailsData?.externalStoreId}/scan-to-order`}
              className="border text-sm text-white border-blue-500 bg-blue-600 rounded-lg py-2 w-[180px] items-center flex gap-2 justify-center hover:bg-blue-700 transition-colors"
            >
              <ArrowRight size={18} />
              Scan To Order
            </Link>

            <Link
              to={`/stores/${onlineStoreDetailsData?.externalStoreId}/online`}
              className="border text-sm text-white border-blue-500 bg-blue-600 w-[180px] rounded-lg py-2 items-center flex gap-2 justify-center hover:bg-blue-700 transition-colors"
            >
              <ArrowRight size={18} />
              Online
            </Link>

            <Link
              to={`/stores/${onlineStoreDetailsData?.externalStoreId}/appointments`}
              className="border text-sm text-white border-blue-500 bg-blue-600 w-[180px] rounded-lg py-2 items-center flex gap-2 justify-center hover:bg-blue-700 transition-colors"
            >
              <ArrowRight size={18} />
              Appointments
            </Link>

            <Link
              to={`/stores/${onlineStoreDetailsData?.externalStoreId}/bookings`}
              className="border text-sm text-white border-blue-500 bg-blue-600 w-[180px] rounded-lg py-2 items-center flex gap-2 justify-center hover:bg-blue-700 transition-colors"
            >
              <ArrowRight size={18} />
              Hotel Bookings
            </Link>
          </div>
        </div>
      )}
    </div>
  );
}
